import { requestJson } from "./instateamEmployeeApi";

export function getEmployeeSettings(token) {
  return requestJson("/instateam/auth/employee/settings", {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
}

export function updateEmployeeSettings(token, settings) {
  return requestJson("/instateam/auth/employee/settings", {
    method: "PATCH",
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ settings }),
  });
}

export function changeEmployeePassword(token, payload) {
  return requestJson("/instateam/auth/employee/change-password", {
    method: "PATCH",
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
    body: JSON.stringify(payload),
  });
}
